import React from "react";

const Login = () => {
  const handleInstall = () => {
    window.location.href = "/install";
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Welcome to AltTextify for Ecwid</h1>
        <p>
          Install AltTextify to manage alt text for all your store images and support
          ADA compliance with accessible, descriptive image descriptions.
        </p>
        <button className="install-button" onClick={handleInstall}>
          Install AltTextify
        </button>
      </div>
    </div>
  );
};

export default Login; 